import React from 'react';
import { DatePickerTemplate } from 'themes/components';

class DatePicker extends React.Component {
	render() {
		return <DatePickerTemplate {...this.props} />;
	}
}

export default DatePicker;
